import { createContext, useContext } from 'react';

interface AutoSaveContextState {
  loading: boolean;
}

const AutoSaveContext = createContext<AutoSaveContextState>({ loading: false });

export const useAutoSaveContext = () => useContext(AutoSaveContext);

export default AutoSaveContext;
